import {
  OPEN_PLATFORM_LOGIN_REPLACE_VIEW,
  OPEN_PLATFORM_LOGIN_SET_APP,
  OPEN_PLATFORM_LOGIN_SET_IS_MOKA_OPEN_API_REDIRECT,
} from './types';

export function replaceView({ next }) {
  return { type: OPEN_PLATFORM_LOGIN_REPLACE_VIEW, payload: { next } };
}

export function setIsMokaOpenApiRedirect({ isMokaOpenApiRedirect }) {
  return {
    type: OPEN_PLATFORM_LOGIN_SET_IS_MOKA_OPEN_API_REDIRECT,
    payload: { isMokaOpenApiRedirect },
  };
}

export function setApp({ app }) {
  return { type: OPEN_PLATFORM_LOGIN_SET_APP, payload: { app } };
}
